<template>
  <div class="festival-wrap">
    <div class="festival-inner">
      <header class="festival-header">
        <h1 class="header__logo">
          <img src="../../assets/images/festival/ic-music-festival.png" class="logo__img" alt="2019 KBS 가요대축제">
        </h1>
      </header>
      <div class="festival-container">
        <section>
          <p class="festival__desc">
            <span>TV로는 볼 수 없는</span>
            <strong>
              <span>포토월 무료 생중계</span>
              <span>지금! <img src="../../assets/images/festival/ic-wavve-big.png" alt="웨이브" class="festival__logo-wavve">에서!</span>
            </strong>
          </p>
          <div class="lineup__list-box">
            <h2>포토월 라인업</h2>
            <p class="lineup__list">
              <!--
              <span>#BTS #TWICE #레드벨벳 #마마무 #ITZY #GOT7 #송가인</span>
              <span>#세븐틴 #몬스타엑스 #뉴이스트 #NCT127 #NCTDREAM</span>
              <span>#StrayKids #더보이즈 #아스트로 #에버글로우 #에이핑크</span>
              <span>#엔플라잉 #여자친구 #오마이걸 #우주소녀 #청하</span>
               -->
              <span>#BTS #TWICE #레드벨벳 #마마무 #ITZY</span>
              <span>#GOT7 #송가인 #세븐틴 #몬스타엑스 #청하</span>
              <span>#뉴이스트 #NCT127 #NCTDREAM #StrayKids</span>
              <span> #더보이즈 #아스트로 #에버글로우 #에이핑크</span>
              <span>#엔플라잉 #여자친구 #오마이걸 #우주소녀</span>
            </p>
          </div>
          <div class="festival__link-box">
            <a href="#" class="link-common link-onair" @click.prevent="goToLive()">
              <img src="../../assets/images/festival/ic-badge.png" alt="무료" class="badge-only">
              포토월 LIVE 보기
            </a>
            <a href="#" class="link-common link-wavve" @click.prevent="moveHome()">
              Wavve 홈으로 가기
            </a>
          </div>
          <div class="exclamation-box">
            <h2 class="a11y-hidden">주의사항</h2>
            <p>생중계 시간은 현장 상황에 따라 변동될 수 있음을 양해드립니다.</p>
            <p>
              <span>2019 KBS 가요대축제 포토월 LIVE는 Wavve에서 무료로 시청 가능하며, 유투브 KBS KPop 채널에서도 시청 할 수 있습니다.</span>
            </p>
          </div>
        </section>
        <footer>
          <h2 class="a11y-hidden">관련된 회사</h2>
          <ul class="footer__list">
            <li class="footer__list--item item-kbs">
              <img src="../../assets/images/festival/ic-kbs.png" alt="KBS">
            </li>
            <li class="footer__list--item item-skt">
              <img src="../../assets/images/festival/ic-skt-5gx.png" alt="SKT 5GX 미디어">
            </li>
            <li class="footer__list--item item-wavve">
              <img src="../../assets/images/festival/ic-wavve-small.png" alt="웨이브">
            </li>
          </ul>
        </footer>
      </div>
    </div>
  </div>

</template>

<script>
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { enableBodyScroll } from '@/common/util/ui.utils'
import { CONFIRM_EMERGENCY } from '@/common/constant'
import { PATH_NAME_HOME } from '@/common/router.const'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
export default {
  data () {
    return {
      device: '',
      title: '',
      channelId: '',
      startTime: ''
    }
  },
  methods: {
    moveHome () {
      sessionStorage.setItem(CONFIRM_EMERGENCY, 'y')
      if (this.device === DEVICE_TYPE_IOS && get(window, ['webkit', 'messageHandlers'], '') !== '') {
        window.webkit.messageHandlers.WebClose.postMessage('WebClose')
      } else if (this.device === DEVICE_TYPE_ANDROID && get(window, 'Android', '') !== '') {
        location.href = 'captvpooq://webclose'
      } else {
        this.$router.push({ name: PATH_NAME_HOME })
      }
    },
    goToLive () {
      if (this.device === DEVICE_TYPE_IOS) {
        utils.common.checkInstallApps(`player/emergency/live?channelid=${this.channelId}&title=${this.title}&starttime=${this.startTime}`)
      } else if (this.device === DEVICE_TYPE_ANDROID) {
        location.href = `captvpooq://player/emergency/live?channelid=${this.channelId}&title=${this.title}&starttime=${this.startTime}`
      } else {
        utils.common.checkInstallApps('player')
      }
    }
  },
  created () {
    enableBodyScroll()
    this.device = get(this.$route, ['query', 'device'], '')
    this.title = get(this.$route, ['query', 'title'], '이벤트')
    this.channelId = get(this.$route, ['query', 'channelid'], 'C9232')
    this.startTime = get(this.$route, ['query', 'starttime'], '16:30')
  }
}
</script>
<style lang="css" src="@/assets/new-css/festival.css"></style>
